import {
  Box,
  Chip,
  FormControl,
  FormLabel,
  Select,
  type SelectProps,
  selectClasses
} from '@mui/joy';

import { ChevronDown } from 'lucide-react';
import type { ReactNode } from 'react';

interface MultiSelectFieldProps extends SelectProps<string, true> {
  label?: string;
  children: ReactNode;
  size?: 'sm' | 'md' | 'lg';
  required?: boolean;
}

export const MultiSelectField = (props: MultiSelectFieldProps) => (
  <FormControl size={props.size || 'sm'}>
    {props.label && (
      <FormLabel required={props.required}>{props.label}</FormLabel>
    )}
    <Select
      indicator={<ChevronDown size={15} />}
      multiple
      placeholder="Select values"
      renderValue={selected => (
        <Box sx={{ display: 'flex', gap: '0.25rem' }}>
          {selected.map(selectedOption => (
            <Chip color="neutral" size="sm" variant="soft">
              {selectedOption.label}
            </Chip>
          ))}
        </Box>
      )}
      size="sm"
      slotProps={{
        listbox: {
          sx: {
            width: '100%'
          }
        }
      }}
      sx={{
        [`& .${selectClasses.indicator}`]: {
          transition: '0.2s',
          [`&.${selectClasses.expanded}`]: {
            transform: 'rotate(-180deg)'
          }
        },
        backgroundColor: 'white' //! temp
      }}
      {...props}
    />
  </FormControl>
);
